import { render, staticRenderFns } from "./bundleModal.vue?vue&type=template&id=5391224a&scoped=true"
import script from "./bundleModal.vue?vue&type=script&lang=js"
export * from "./bundleModal.vue?vue&type=script&lang=js"
import style0 from "./bundleModal.vue?vue&type=style&index=0&id=5391224a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391224a",
  null
  
)

export default component.exports